export default __webpack_public_path__ + "static/media/mentorsIcon.1414f0d4.svg";